<template>
  <div>
    <span
      v-if="title !== ''"
      class="span-title pl-1"
    >{{ title }}</span>
    <div class="row nopads">
        <div class="col-sm-5">
            <input
                :value="updateCoordinate.y"
                @input="v => { updateCoordinate.y = Number(v.target.value); $forceUpdate(); }"
                type="number"
                step="0.0000000000001"
                :placeholder="$t('common.latitude')"
                :class="['form-control', 'form-control-' + size, 'col-sm-4', 'm-1']"
                :disabled="disabled"
            />
        </div>
        <div class="col-sm-5">
            <input
                :value="updateCoordinate.x"
                @input="v => { updateCoordinate.x = Number(v.target.value); $forceUpdate(); }"
                type="number"
                class="col-sm-5"
                step="0.0000000000001"
                :placeholder="$t('common.longitude')"
                :class="['form-control', 'form-control-' + size, 'col-sm-4', 'm-1']"
                :disabled="disabled"
            />
        </div>
        <div class="col-2">
            <button
                v-if="mapAvailable"
                class="btn btn-sm m-1 p-1 col-2"
                style="height: 2em; width: 2em"
                :class="{'btn-primary' : !showMap}"
                @click.stop="showMap = !showMap"
            >
                <i class="fa fa-map" />
            </button>
        </div>
    </div>
    <div
      v-if="mapAvailable && showMap"
      class="coordinate-map"
    >
      <marker-editor-map
        ref="mapComponent"
        :lat="updateCoordinate.y"
        :lon="updateCoordinate.x"
        :type="pointType"
        :draggable="!disabled"
        :show-buttons="false"
        @on-drag-marker="updateLocation"
        @on-map-clicked="updateLocation"
      />
    </div>
    <div
      v-if="showButtons"
      class="col-sm-12 button-container"
    >
      <button
        v-show="showMap"
        class="btn btn-sm btn-danger form-button"
        @click.stop="resetLocation"
      >
        {{ $t('common.reset') }}
      </button>
      <button
        v-show="showMap"
        class="btn btn-sm btn-success form-button"
        @click.stop="setLocation"
      >
        {{ $t('common.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import MarkerEditorMap from '../map/MarkerEditorMap'

export default {
    name: 'RouteOptimizationCoordinateEditor',
    components: {MarkerEditorMap},
    props: {
        modelValue: {
            type: Object,
            default: null
        },
        title: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'sm'
        },
        pointType: {
            type: Number,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showButtons: {
            type: Boolean,
            default: true
        },
        skipDefaults: {
            type: Boolean,
            default: false
        },
        allowAutoPosition: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showMap: false,
            updateCoordinate: {}
        }
    },
    computed: {
        mapAvailable() {
            return this.pointType != null && !isNaN(this.pointType)
        }
    },
    mounted() {
        this.updateCoordinate = this.modelValue || { x: null, y: null }
        
        if (!this.skipDefaults && (!this.updateCoordinate.x || !this.updateCoordinate.y)) {
            navigator.geolocation.getCurrentPosition(
                ({ coords: { latitude, longitude } }) => {
                    this.updateCoordinate.x = longitude
                    this.updateCoordinate.y = latitude
                    this.$forceUpdate()
                },
                () => {
                    this.updateCoordinate.x = 25.8
                    this.updateCoordinate.y = 62.2
                    this.$forceUpdate()
                },
                { timeout: 30000 }
            )
        }
    },
    watch: {
        modelValue: {
            handler(newVal) {
                if (newVal && this.allowAutoPosition && (newVal.x !== this.updateCoordinate.x || newVal.y !== this.updateCoordinate.y)) {
                    this.updateCoordinate = { ...newVal }
                }
            },
            deep: true,
            immediate: true
        },
        allowAutoPosition: {
            handler(newVal) {
                if (newVal && this.modelValue) {
                    this.updateCoordinate = { ...this.modelValue }
                    this.$nextTick(() => {
                        if (this.$refs.mapComponent) {
                            this.$refs.mapComponent.draw()
                        }
                    })
                }
            }
        }
    },
    methods: {
        setLocation() {
            this.$emit('update:modelValue', this.updateCoordinate)
        },

        updateLocation(location) {
            if(location.lat && location.lng) {
                this.updateCoordinate.x = location.lng
                this.updateCoordinate.y = location.lat
            } else if(location.x && location.y) {
                this.updateCoordinate.x = location.x
                this.updateCoordinate.y = location.y
            }
            this.$emit('update:modelValue', this.updateCoordinate)
            this.$emit('manual-position-set')
            this.$nextTick(() => {
                if (this.$refs.mapComponent) {
                    this.$refs.mapComponent.draw()
                }
            })
        },

        resetLocation: function () {
            this.location = null
            this.updateCoordinate = {}
            this.$emit('close')
        },
    }
}
</script>

<style scoped>

</style>